import React, { Component } from 'react'

class SvgFile extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="36"
        height="36"
        viewBox="0 0 36 36"
      >
        <g fill="#3E414A" fillRule="nonzero">
          <path d="M25.076 11.941a6.013 6.013 0 0 1-1.889.724 2.989 2.989 0 0 0-2.17-.927 2.945 2.945 0 0 0-2.968 2.895c0 .224.027.448.08.666a8.475 8.475 0 0 1-6.123-3.054c-.26.438-.4.938-.405 1.447 0 .983.499 1.899 1.324 2.432a2.996 2.996 0 0 1-1.346-.37v.037a2.938 2.938 0 0 0 2.381 2.895 3.033 3.033 0 0 1-1.339.05 2.967 2.967 0 0 0 2.772 2.027A6.014 6.014 0 0 1 11 21.986a8.503 8.503 0 0 0 4.552 1.317 8.323 8.323 0 0 0 8.475-8.315v-.377a6.014 6.014 0 0 0 1.447-1.512 6.006 6.006 0 0 1-1.708.463 2.945 2.945 0 0 0 1.31-1.621z" />
          <path d="M18 36C8.059 36 0 27.941 0 18S8.059 0 18 0s18 8.059 18 18-8.059 18-18 18zm0-.973c9.404 0 17.027-7.623 17.027-17.027S27.404.973 18 .973.973 8.596.973 18 8.596 35.027 18 35.027z" />
        </g>
      </svg>
    )
  }
}

export default SvgFile
